module.exports = __webpack_public_path__ + "img/home.97f5df82.png";